import React from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '@mui/material/Card';
import { Button, Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useMediaQuery } from '@mui/material';
import { useTheme, Theme } from '@mui/material/styles';
import WorkIcon from '@mui/icons-material/Work';
import SchoolIcon from '@mui/icons-material/School';
import DateRangeIcon from '@mui/icons-material/DateRange';
import PlaceIcon from '@mui/icons-material/Place';
import Grid from '@mui/material/Grid2';
import EastSharpIcon from '@mui/icons-material/EastSharp';
import WestSharpIcon from '@mui/icons-material/WestSharp';
import { buttonStyles } from '../utils/utils';

const experiences = [
  {
    role: 'Full Stack Developer',
    company: 'American Express',
    location: 'Phoenix, AZ, US',
    time: 'February 2024 - Present',
    icon: <SchoolIcon />,
  },
  {
    role: 'Technical Lead',
    company: 'Bicycle Works',
    location: 'St. Louis, MO, US',
    time: 'August 2024 - December 2024',
    icon: <SchoolIcon />,
  },
  {
    role: 'Research Full Stack Developer',
    company: 'Saint Louis University',
    location: 'St. Louis, MO, US',
    time: 'January 2023 - February 2024',
    icon: <SchoolIcon />,
  },
  {
    role: 'Full Stack Developer',
    company: 'Optum',
    location: 'Hyderabad, IN',
    time: 'February 2021 - December 2022',
    icon: <WorkIcon />,
  },
  {
    role: 'Full Stack Developer',
    company: 'The Home Depot',
    location: 'Hyderabad, IN',
    time: 'January 2019 - February 2021',
    icon: <WorkIcon />,
  },
];

const WorkExperience: React.FC<{ isSidebarOpen: boolean; }> = ({ isSidebarOpen }) => {
  const navigate = useNavigate();
  const theme = useTheme<Theme>(); // Get the theme and ensure it is of type Theme
  const isLargerThanMedium = useMediaQuery(theme.breakpoints.up('md'));
  const isLargerThanSmall = useMediaQuery(theme.breakpoints.up('sm'));
  const isLargerThanLarge = useMediaQuery(theme.breakpoints.up('lg'));

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <Box
      sx={{
        // p: isLargerThanSmall ? (isLargerThanLarge ? 12 : 10) : 6,
        p: 4,
        pb: 8,
        pl: isLargerThanSmall ? (isLargerThanLarge ? 12 : 8) : (isSidebarOpen? 3: 5),
        pr: isLargerThanSmall ? (isLargerThanLarge ? 12 : 8) : 3,
        // pt: isLargerThanSmall? 8: 6,
        overflow: 'auto',
        backgroundColor: '#fffde780',
        boxSizing: 'border-box'
      }}>
      <Typography variant="h2" component="h2" sx={{ mb: 2, mt: 2, textAlign: 'center' }}>
        Work Experience
      </Typography>
      <Grid sx={{ display: 'flex', justifyContent: 'space-between', mb: 5 }}>
        <div>
          <Button
            sx={buttonStyles}
            variant="contained" color="primary" endIcon={<WestSharpIcon/>}
            onClick={() => handleNavigation('/academic-projects')}>
            {isLargerThanMedium ? 'Academic Projects' : 'Projects'}
          </Button>
        </div>
        <div>
          <Button 
            sx={buttonStyles}
            variant="contained" color="primary" startIcon={<EastSharpIcon/>}
            onClick={() => handleNavigation('/certifications')}>
            Certifications
          </Button>
        </div>
      </Grid>
      <Grid container spacing={4}>
      {experiences.map((exp, index) => (
        <Grid size={{ xs: 12 }} key={index}>
          <Card
            sx={{
              backgroundColor: 'rgb(255, 253, 231, 0.7)',
              display: 'flex',
              justifyContent: 'space-between',
              p: isLargerThanMedium ? 4 : 2,
              boxShadow: 6,
              overflow: 'visible',
            }}
          >
            <Grid container spacing={2}>
              {/* Left Section */}
              <Grid size={{ xs: 12 }}>
                <Typography variant="h5" sx={{ my: 1, mt: 0, mb: 2 }}>
                  {exp.role} - {exp.company}
                </Typography>
                <Grid container direction="column" spacing={1}>
                  <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                    <PlaceIcon sx={{ mr: 1, color: 'primary.main' }} />
                    <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontWeight: '550' }}
                >{exp.location}</Typography>
                  </Grid>
                  <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                    <DateRangeIcon sx={{ mr: 1, color: 'primary.main' }} />
                    <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontWeight: '550' }}
                >{exp.time}</Typography>
                  </Grid>
                </Grid>
                
              </Grid>
            </Grid>
          </Card>
        </Grid>
      ))}
      </Grid>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 10, mb: 2 }}>
        <div>
          <Button
            sx={buttonStyles}
            variant="contained" color="primary" endIcon={<WestSharpIcon/>}
            onClick={() => handleNavigation('/academic-projects')}>
            {isLargerThanMedium ? 'Academic Projects' : 'Projects'}
          </Button>
        </div>
        <div>
          <Button 
            sx={buttonStyles}
            variant="contained" color="primary" startIcon={<EastSharpIcon/>}
            onClick={() => handleNavigation('/certifications')}>
            Certifications
          </Button>
          </div>
      </Box>
    </Box>
  );
}

export default WorkExperience;